{
  "generic": {
    "no": "Não",
    "yes": "Sim",
    "text": "Texto "
  },
  "consent": {
    "defaultLabelText": "Ao enviar este formulário, você concorda com a nossa ",
    "defaultLabelLink": "política de privacidade"
  },
  "text": {
    "defaultHeadlineText": "Isto é um título",
    "defaultText": "Isto é um bloco de texto",
    "floatingDefaultText": "NOVO!"
  },
  "button": {
    "submitDefaultText": "Enviar",
    "instagramDefaultText": "Siga-nos",
    "defaultText": "Clique aqui",
    "closing": "FECHANDO..."
  },
  "input": {
    "emailLabel": "E-mail",
    "emailPlaceholder": "Digite seu e-mail",
    "passwordLabel": "Senha",
    "passwordPlaceholder": "Digite a senha",
    "nameLabel": "Nome",
    "namePlaceholder": "Digite seu nome",
    "firstNameLabel": "Primeiro Nome",
    "firstNamePlaceholder": "Digite o primeiro nome",
    "lastNameLabel": "Sobrenome",
    "lastNamePlaceholder": "Digite o sobrenome",
    "phoneLabel": "Telefone",
    "phonePlaceholder": "Digite o número de telefone",
    "textareaLabel": "Mensagem",
    "textareaPlaceholder": "Digite sua mensagem",
    "regularLabel": "Texto",
    "regularPlaceholder": "Digite o texto",
    "defaultLabel": "Rótulo",
    "defaultPlaceholder": "Espaço reservado",
    "datePlaceholder": "Selecione a data",
    "stepLabel": "Digite sua pergunta aqui"
  },
  "dropdown": {
    "placeholder": "Selecione uma opção",
    "firstItem": "Opção 1",
    "secondItem": "Opção 2",
    "chooseCountry": "País"
  },
  "buttonList": {
    "firstItem": "Opção 1",
    "secondItem": "Opção 2",
    "option1": "Escolha 1",
    "option2": "Escolha 2",
    "option3": "Escolha 3",
    "subscriptionItem1": "Boletim informativo",
    "subscriptionItem2": "Atualizações",
    "chooseSubscriptionTopics": "Escolha tópicos de assinatura",
    "other": "Outro",
    "uncheck-all-label": "Não desejo receber nenhum destes e-mails"
  },
  "rating": {
    "rateLabel": "Avalie-nos",
    "npsLabel": "Qual a probabilidade de você nos recomendar?",
    "veryUnsatisfied": "Muito insatisfeito",
    "unsatisfied": "Insatisfeito",
    "neutral": "Neutro",
    "satisfied": "Satisfeito",
    "loveIt": "Adoro!",
    "minValueLabel": "Baixo",
    "maxValueLabel": "Alto",
    "minValueLabelNps": "Pouco provável",
    "maxValueLabelNps": "Muito provável"
  },
  "deadline": {
    "days": "Dias",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos"
  },
  "bulletList": {
    "firstItem": "Benefício 1",
    "secondItem": "Benefício 2"
  },
  "discountCode": {
    "copyMessage": "Copiado para a área de transferência!",
    "fallback": "WELCOME10",
    "textDefault": "Seu código de desconto",
    "buttonDefault": "Copiar"
  },
  "share": {
    "buttonText": "Compartilhar"
  },
  "common": {
    "label": "Rótulo"
  },
  "wcag": {
    "banner": "Banner promocional",
    "closeButton": "Fechar",
    "submitButton": "Enviar formulário"
  },
  "spinTheWheel": {
    "prizeWonText": "Parabéns!",
    "prizeWonButtonText": "Reivindique seu prêmio",
    "prizeLostText": "Ahhh, que pena! :-(",
    "prizeLostButtonText": "Clique para fechar",
    "spinButtonLabel": "GIRAR"
  },
  "memory": {
    "resultWonText": "Bom trabalho! Seu tempo foi {elapsedTime}",
    "resultWonButtonText": "Reivindique seu prêmio"
  },
  "stepNavigation": {
    "nextButtonText": "Avançar",
    "previousButtonText": "Voltar",
    "lastButtonText": "Fechar",
    "submitButtonText": "Enviar"
  },
  "defaultRealTimeMessage": {
    "validationError": "Por favor, reveja o formato dos dados enviados.",
    "unknownError": "Ocorreu um problema inesperado ao enviar.",
    "conflictError": "Este utilizador já existe.",
    "success": "Formulário enviado."
  }
}
